import { useSetRoute } from '@features/app-hooks'
import { useOrganization } from '@features/organizations'
import { Button, Dialog, DialogButtons } from '@st/theme'

type Props = {
  currentBalance: number
  onClose: () => void
}

export function OrganizationLowBalanceFolderOpenDialog({ currentBalance, onClose }: Props) {
  const setRoute = useSetRoute()
  const organization = useOrganization()

  return (
    <Dialog
      title="Purchase credits to open binders"
      subtitle={`Your credit balance is ${currentBalance}. Please purchase additional credits to continue using StanfordTax.`}
      buttons={
        <DialogButtons>
          <Button variant="subtle" onClick={onClose}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() =>
              setRoute({
                name: 'organization_balance',
                organizationSlug: organization.slug
              })
            }
          >
            View balance
          </Button>
        </DialogButtons>
      }
    />
  )
}
